/**
 * CAT Status Chip Component
 *
 * Displays the status of a CAT with appropriate color.
 */

import React from 'react';
import { Chip, ChipProps } from '@mui/material';
import { CatStatus, CAT_STATUS_LABELS, CAT_STATUS_COLORS } from '../../../types/cat';

interface CatStatusChipProps extends Omit<ChipProps, 'color' | 'label'> {
  status: CatStatus;
}

export const CatStatusChip: React.FC<CatStatusChipProps> = ({ status, ...props }) => {
  return (
    <Chip
      label={CAT_STATUS_LABELS[status] || status}
      color={CAT_STATUS_COLORS[status] || 'default'}
      size="small"
      {...props}
    />
  );
};

export default CatStatusChip;
